import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import Player from '@vimeo/player';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Cookies from "js-cookie";
import iFrameResizer from "iframe-resizer/js/iframeResizer";
import Lenis from 'lenis'

Fancybox.bind("[data-fancybox]", {});

jQuery(document).ready(function($) {
	var windowWidth = $(window).width();

/* ====================== INIT LENIS SMOOTH SCROLL ======================  */
	const lenis = new Lenis();
	lenis.on('scroll', ScrollTrigger.update);
	gsap.ticker.add((time) => {
	  lenis.raf(time * 1000);
	});
	gsap.ticker.lagSmoothing(0);

/* ====================== iFrame Resize ======================  */
	const iframes = iFrameResizer({
		waitForLoad: true,
		onResized: function() {
			ScrollTrigger.refresh();
		}
	}, 'iframe');

/* ====================== iPhone 100vh Workaround ======================  */
	if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) && window.innerHeight > window.innerWidth) {
	  let vh = window.innerHeight * 0.01;
	  document.documentElement.style.setProperty('--vh', vh+'px');
	  document.documentElement.style.setProperty('--staticvh', vh+"px");
	  window.addEventListener('resize', function() {
	    let vh = window.innerHeight * 0.01;
	    document.documentElement.style.setProperty('--vh', vh+'px');
	  });
	}

	$('.news-card').on("click", function() {
		var link = $(this).find('.text-link').attr('href');
		window.location.href = link;
	});

//========== Simple Page loader ==========//
    $('.page-loader').addClass('page-loader--hidden');
    $('.page-loader').removeClass('page-loader--change');

    function page_change() {
     var windowWidth = $(window).width()

        if(windowWidth > 992) {
         $('a').not('.video-popup-trigger, .button, .cd-upload-btn, .lightbox-image, .social-share-link, a[href*="#"], .fancybox-link, a[href^="mailto:"], a[href^="tel:"], .remodal-close, .social-share__link, a[target="_blank"], a[data-remodal-target="resource-modal"], .download-link, .newsletter-link, .research-download, .ab-item, .close, .text-link').click(function(e) {
           e.preventDefault();
           $('.page-loader').addClass('page-loader--change');
           setTimeout(function(url) { window.location = url }, 250, this.href);
         });
        }
    }

    page_change();

	window.addEventListener("pageshow", function(evt){
	        if(evt.persisted){
	        setTimeout(function(){
	            window.location.reload();
	        },10);
	    }
	}, false);

/* ====================== Semi Sticky Nav ======================  */
	var prevScrollpos = window.pageYOffset;
	var currentScrollPos = window.pageYOffset;

	if(currentScrollPos > 120) {
		$("header").addClass("headerscrolled");
	}

	document.addEventListener('scroll', function (event) {
		var currentScrollPos = window.pageYOffset;

		if ((prevScrollpos > currentScrollPos)) {
			$('header').addClass('show');
			$('.anchor-navigation').addClass('append-to-header');
		} else if((prevScrollpos < currentScrollPos)){
			$('header').removeClass('show');
			$('.anchor-navigation').removeClass('append-to-header');
		}
		else {
			$('header').removeClass('show');
		}

		if(currentScrollPos > 120) {
			$("header").addClass("headerscrolled");
		} else {
			$("header").removeClass("headerscrolled show");
			$('.anchor-navigation').removeClass('append-to-header');
		}

		prevScrollpos = currentScrollPos;
	}, true);

/* ====================== Cookiebot ======================  */
	$('.update-cookie-consent').on("click", function(e) {
		e.preventDefault();
		Cookiebot.renew();
	});

/* ====================== MOBILE NAV ======================  */
    $('.menu-toggle').on("click", function() {
        $(this).toggleClass('active');
        $('header nav').toggleClass('open');
        $('header').toggleClass('open');
        $('.behind-nav-bg').toggleClass('open');
        $('body').toggleClass('noscroll');
    })

    if(windowWidth < 1023) {
    	var itemHeight = $('#menu-main-menu a').outerHeight();
    	$('.main-nav > li a').not('.sub-menu a').css('height', itemHeight);
    	$('.main-nav > li a').not('.sub-menu a').css('min-height', itemHeight);

	    $('#menu-main-menu .menu-item-has-children').on("click", function() {
	    	if($(this).hasClass('open')) {
	    		$(this).removeClass('open');
	       		$(this).find('.sub-menu').slideUp();
	    	} else {
	    		$('#menu-main-menu .menu-item-has-children').removeClass('open');
	       		$('.sub-menu').slideUp();

	       		$(this).addClass('open');
	       		var subMenu = $(this).find('.sub-menu').slideDown();

	       		if($(this).is(':not(:first-child)')) {
		            subMenu.promise().done(function() {
		            	var position = subMenu.offset().top - $('header nav').offset().top - itemHeight;
		                $('header nav').animate({
		                    scrollTop: position + $('header nav').scrollTop()
		                }, 150);
		            });
	       		}
	    	}
	    })

	    $('.sub-menu a').on("click", function(event) {
	        event.stopPropagation();
	    });
	}

/* ====================== Gravity Form - Amend Date Picker ======================  */
	if (typeof gform !== 'undefined') {
		gform.addFilter( 'gform_datepicker_options_pre_init', function( optionsObj, formId, fieldId ) {
		    optionsObj.firstDay = 1;
		    optionsObj.beforeShowDay = function(date) {
		        var day = date.getDay();
		        var today = new Date();
		        today.setHours(0,0,0,0);
		        return [(date >= today), ''];
		    };
		    return optionsObj;
		});
	}

/* ====================== Updating Form IDs ======================  */
	$('.gfield.appointment_id input').attr('id', 'appointment_id');
	$('.gfield.preferred_datetime input').attr('id', 'preferred_datetime');

	// On Forms that don't redirect - hide disclaimer
	$(document).on("gform_confirmation_loaded", function (e, form_id) {
		$('.form-disclaimer').hide();
		ScrollTrigger.refresh();
	});

/* ====================== Accordion ======================  */
	//$('.accordion .accordion-row:first-of-type .accordion-row-intro').addClass('active');
	//$('.accordion .accordion-row:first-of-type .accordion-row-content').slideDown();
	//$('.accordion .accordion-row:first-of-type .accordion-row-content').addClass('active');

	$('.accordion .accordion-title').on('click', function () {
		if($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).next('.accordion-content').slideUp(250);
			$(this).next('.accordion-content').removeClass('active');
		} else {
			$('.accordion .accordion-title').removeClass('active');
			$('.accordion-content').slideUp(250);
			$('.accordion-content').removeClass('active');

			$(this).addClass('active');
			$(this).next('.accordion-content').slideDown(250);
			$(this).next('.accordion-content').addClass('active');

			var row = $(this);
			setTimeout(function(){
		        $('html,body').animate({
			   		scrollTop: $(row).offset().top
				});
	        },250);
		}
    });

/* ====================== Hero - Background Image Carousel ======================  */
	const hero_image_carousel = new Swiper('.hero.image-carousel .swiper', {
       slidesPerView: 1,
       loop: true,
        speed: 1000,
        effect: "fade",
       	fadeEffect: { crossFade: true },
       	watchSlidesProgress: true,
       	autoplay: {
        	delay: 4000,
        	disableOnInteraction: false,
      	},
       	pagination: {
			el: ".hero.image-carousel .swiper-pagination",
			clickable: true,
		},
	});

/* ====================== Hero - Carousel ======================  */
	const hero_carousel = new Swiper('.hero.carousel .swiper', {
       slidesPerView: 1,
       loop: true,
        speed: 1000,
        effect: "fade",
       	fadeEffect: { crossFade: true },
       	watchSlidesProgress: true,
       	autoplay: {
        	delay: 4000,
        	disableOnInteraction: false,
      	},
       	pagination: {
			el: ".hero.carousel .swiper-pagination",
			clickable: true,
		},
	});

/* ====================== Carousel Navigation ======================  */
	const carousel_navigation = new Swiper('.carousel-navigation .swiper', {
       slidesPerView: 1.3,
       loop: true,
       speed: 1000,
       centeredSlides: true,
       spaceBetween: 30,
       watchSlidesProgress: true,
		breakpoints: {
			1024: {
				slidesPerView: 1.5,
				spaceBetween: 60,
			},
			1280: {
				slidesPerView: 1.5,
				spaceBetween: 130,
			},
		},
	});

	$('.carousel-navigation').on( 'click', '.swiper-slide-next', function( e ){
		carousel_navigation.slideNext();
	});

	$('.carousel-navigation').on( 'click', '.swiper-slide-prev', function( e ){
		carousel_navigation.slidePrev();
	});

/* ====================== Content and Image Carousel ======================  */
	const content_and_image_carousel = new Swiper('.content-and-image-carousel .swiper', {
       slidesPerView: 1.2,
       spaceBetween: 30,
       speed: 1000,
       loop: true,
       watchSlidesProgress: true,
       slideToClickedSlide: true,
       	pagination: {
			el: ".content-and-image-carousel .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			767: {
				slidesPerView: 1.05,
			},
			1024: {
				slidesPerView: 1.05,
				spaceBetween: 0,
			},
		},
	});

	// Positioning pagination based on active slide width
	if(windowWidth < 1024) {
		$(window).on('load', function() {
			setTimeout(function(){
	       		var slideWidth = $('.content-and-image-carousel .swiper-slide-active').width()
				$('.content-and-image-carousel .swiper-pagination').css('left', slideWidth);
	        },1000);

		});
	}

	$('.content-and-image-carousel').on( 'click', '.swiper-slide-next', function( e ){
		content_and_image_carousel.slideNext();
	});

	$('.content-and-image-carousel').on( 'click', '.swiper-slide-prev', function( e ){
		content_and_image_carousel.slidePrev();
	});


/* ====================== Generic Media Swiper ======================  */
    $('.media-carousel').each(function(index, element) {
    	var number = $(element).find('.swiper-slide').length;

    	if(number > 1) {
	        const media_carousel = new Swiper(element, {
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
				},
	            slidesPerView: 1,
	            speed: 600,
	            loop: true,
	            watchSlidesProgress: true,
	            spaceBetween: 10,
				pagination: {
					el: ".media-carousel .swiper-pagination",
					clickable: true,
				},
	        });
	    }
    });


/* ====================== Carousel Timeline ======================  */
	const carousel_timeline = new Swiper('.carousel-timeline .swiper', {
       slidesPerView: 1.3,
       centeredSlides: true,
       loop: true,
       spaceBetween: 30,
       speed: 1000,
       	breakpoints: {
			768: {
				slidesPerView: 1.8,
				spaceBetween: 60,
			},
			1280: {
				slidesPerView: 1.8,
				spaceBetween: 130,
			},
		},
	});

	$('.carousel-timeline').on( 'click', '.swiper-slide-next', function( e ){
		carousel_timeline.slideNext();
	});

	$('.carousel-timeline').on( 'click', '.swiper-slide-prev', function( e ){
		carousel_timeline.slidePrev();
	});

/* ====================== Events Carousel ======================  */
	const events_carousel = new Swiper('.events-carousel .swiper', {
		slidesPerView: 1.3,
		loop: false,
		spaceBetween: 30,
		centeredSlides: true,
		navigation: {
			nextEl: ".events-carousel .swiper-button-next",
			prevEl: ".events-carousel .swiper-button-prev",
		},
		pagination: {
			el: ".events-carousel .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 1.8,
				spaceBetween: 30,
			},
			1280: {
				centeredSlides: false,
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1350: {
				centeredSlides: false,
				slidesPerView: 3,
				spaceBetween: 65,
			},
		},
	});

/* ====================== GSAP ANIMATIONS ======================  */
	const parallax_images = gsap.utils.toArray(".image-parallax img");
	parallax_images.forEach((item, index) => {
		const image_height = $(parallax_images).outerHeight();
		const parallax_parent = $(item).parents('.block');
		const parent_height = $(parallax_parent).outerHeight();

		if(windowWidth > 767) {
			var yDuration = Math.floor((Math.random() * 100) + 100);
		} else{
			var yDuration = Math.floor((Math.random() * 50) + 50);
		}

		if($(item).parent().hasClass('landscape-image-container')) {
			yDuration = yDuration * -1;
		}

		gsap.to(item, {
			y: () => yDuration,
			ease: "power1.in",
			scrollTrigger: {
				trigger: parallax_parent,
				scrub: 2,
				duration: 1,
				start: "top 50%",
				markers: false,
				end: () => parent_height + ' 50%',
				invalidateOnRefresh: true
			}
		});
	});

	let animate = gsap.utils.toArray('.animate')
	animate.forEach((item, index) => {
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: item,
				once: true,
				start:"0 75%",
				toggleActions:"restart none none reset",
				end: "500",
				markers: false,
				toggleClass: 'animateelement'
			}
		});
	});

	// Update scroll trigger if ajax loads
	if ($('.blog-overview').length > 0) {
		function outputsize() {
			var blogOverview = $('.blog-overview');
		 	blogOverview.value = blogOverview[0].offsetHeight
		 	ScrollTrigger.refresh();
		}
		outputsize();
		var blogOverview = $('.blog-overview');
		new ResizeObserver(outputsize).observe(blogOverview[0])
	}

/* ====================== Embedded Hero Video Resizing/ Cover ======================  */
	function throttle(func, wait, options) {
		var context, args, result;
		var timeout = null;
		var previous = 0;
		if (!options) options = {};
		var later = function() {
			previous = options.leading === false ? 0 : Date.now();
			timeout = null;
			result = func.apply(context, args);
			if (!timeout) context = args = null;
		};
		return function() {
			var now = Date.now();
			if (!previous && options.leading === false) previous = now;
			var remaining = wait - (now - previous);
			context = this;
			args = arguments;
			if (remaining <= 0 || remaining > wait) {
			if (timeout) {
				clearTimeout(timeout);
				timeout = null;
			}
			previous = now;
			result = func.apply(context, args);
			if (!timeout) context = args = null;
			} else if (!timeout && options.trailing !== false) {
				timeout = setTimeout(later, remaining);
			}
			return result;
		};
	}

	  // Vimeo JS
	function getVideoDimensions(element) {
		var parentWidth = $(element).outerWidth();
		var parentHeight = $(element).outerHeight();
		var parentRatio = parentWidth / parentHeight;

		var videoWidth;
		var videoHeight;

		var ratio = 16 / 9;

		if (parentRatio >= ratio) {
			// fit to width
			videoWidth = parentWidth;
			videoHeight = parentWidth / ratio;
		} else {
			// fit to height
			videoHeight = parentHeight;
			videoWidth = (parentHeight / 9) * 16;
		}
		return {
			width: videoWidth,
			height: videoHeight
		};
	}

/* ====================== Hero Video Popup ======================  */
	 if ($('.hero iframe').length > 0) {
			$('.hero .background-video').each(function() {
				var heroBGPlayer = this;
				var containerEl = $(heroBGPlayer).parent('.hero').get(0);
				var videoDimensions = getVideoDimensions(heroBGPlayer);

				$(heroBGPlayer).css({
					'height': videoDimensions.height,
					'width': videoDimensions.width,
				});

			$(window).on('resize', throttle(function() {
				videoDimensions = getVideoDimensions(containerEl);
				$(heroBGPlayer).css({
					'height': videoDimensions.height,
					'width': videoDimensions.width,
				});
			}, 250));
		});
	}

	if ($('.hero .popup-player').length > 0) {
		var popupIframe = document.querySelector('.hero .popup-player');
    	var heroBGPlayer = document.querySelector('.hero .background-video');
    	var fullScreenPlayer = new Player(popupIframe);
		var heroBGPlayer = new Player(heroBGPlayer);

		fullScreenPlayer.on('fullscreenchange', function(data) {
		    if(data['fullscreen'] == false) {
		    	 fullScreenPlayer.pause();
		    } else {
		    	heroBGPlayer.play();
		    }
		});

		$('.hero .play-video').on("click", function() {
			heroBGPlayer.pause();
			fullScreenPlayer.setCurrentTime(0);
			fullScreenPlayer.play();

			setTimeout(function(){
	        	fullScreenPlayer.requestFullscreen();
	        },500);
		})
	}


/* ====================== Video Popup ======================  */
	if ($('.video-block').length > 0) {
		var videoBlockVideo = document.querySelector('.video-block .background-video');
		var videoBlockBG = new Player(videoBlockVideo);
		videoBlockBG.play();
	}

	if ($('.video-block iframe').length > 0) {
		$('.video-block .background-video').each(function() {
			var playerEl = this;
			var containerEl = $(playerEl).parent('.video-block').get(0);

			setTimeout(function(){
				var videoDimensions = getVideoDimensions(playerEl);

				$(playerEl).css({
					'height': videoDimensions.height,
					'width': videoDimensions.width,
				});
			}, 250);
		});
	}

    if ($('.video-block .popup-player').length > 0) {
    	var popupIframe = document.querySelector('.video-block .popup-player');
    	var fullScreenPlayer = new Player(popupIframe);

    	var videoBlockBg = document.querySelector('.video-block iframe');
    	var videoBlockBg = new Player(videoBlockBg);

		fullScreenPlayer.on('fullscreenchange', function(data) {
		    if(data['fullscreen'] == false) {
		    	 fullScreenPlayer.pause();
		    }
		});

		$('.video-block .play-icon').on("click", function() {
			videoBlockBg.pause();
			fullScreenPlayer.setCurrentTime(0);
			fullScreenPlayer.play();
			setTimeout(function(){
	       		fullScreenPlayer.requestFullscreen();
	       	}, 100);
		})
	}

/* ====================== Submit Gravity Form ======================  */
     $('.gform_wrapper .gform_button').on('click', function() {
     	$(this).addClass('submitted');
    	//$(this).parents('.gform_wrapper').find('[type=submit]').click();
    });

/* ====================== Select Parent on Checked ======================  */
	$(document).on( 'click', '.gfield.gfield_error input', function( e ){
		$(this).parents('.gfield').find('.validation_message').hide();
		$(this).parents('.gfield').removeClass('gfield_error');
	})

	$(document).on( 'change', '.gfield select', function( e ){
		$(this).parents('.gfield').find('.validation_message').hide();
		$(this).parents('.gfield').removeClass('gfield_error');
	});

	$(document).on( 'change', 'input[type=checkbox]', function( e ){
		if($(this).attr('value') == 'Not Sure') {
			$(this).parents('.gfield_checkbox').find('input').not(this).prop('checked', false);
		} else {
			$(this).parents('.gfield_checkbox').find('input[value="Not Sure"]').prop('checked', false);
		}
	});

/* ====================== Horizontal Scrolling ======================  */
	if ($('.horizontal-image-item').length > 0) {
		const sections = gsap.utils.toArray(".horizontal-image-item");
		const images = gsap.utils.toArray(".horizontal-image-item img");

		let maxWidth = 0;

		const getMaxWidth = () => {
			maxWidth = 0;
			sections.forEach((section) => {
				maxWidth += section.offsetWidth;
			});
		};

		getMaxWidth();

		ScrollTrigger.addEventListener("refreshInit", getMaxWidth);
		gsap.to(sections, {
			x: () => `-${maxWidth - window.innerWidth}`,
			ease: "none",
			scrollTrigger: {
				trigger: ".horizontal-scrolling",
				pin: true,
				scrub: 2,
				start: "top top",
				markers: false,
				end: () => `+=${maxWidth}`,
				invalidateOnRefresh: true
			}
		});

		// Create the parallax effect for images within sections
		sections.forEach(section => {
		const image = section.querySelector('.horizontal-image');
		if (image) {
		  gsap.to(image, {
		    x: () => `-${section.offsetWidth * .2}`, // Adjust the factor for desired lag
		    ease: "none",
		    scrollTrigger: {
		      trigger: section,
		      start: "top bottom",
		      end: () => `+=${maxWidth}`,
		      scrub: 2,
		      invalidateOnRefresh: true
		    }
		  });
		}
		});
	}

/* ====================== Sticky CTA ======================  */
	if($('.sticky-cta').length) {
		if( windowWidth < 1024){
			$('footer').addClass('sticky-cta-present')
		}

		window.addEventListener('scroll', () => {
			if(window.scrollY > 300) {
				$('.sticky-cta').addClass('show');
			} else {
				$('.sticky-cta').removeClass('show');
			}
		});
	}

/* ====================== Table Mobile Notice ======================  */
	document.querySelectorAll('table').forEach((table) => {
		var tbody = $(table).find('tbody');

		/* If the width of the table is bigger than the width of the screen add a .table-notice class to it's parent */
		if($(tbody).width() > window.innerWidth) {
			table.parentElement.classList.add('table-notice');
		}

		/* If any of the columns of the first row of the table is empty (except the first column), we assume that this entire column is empty and add a class to each cell in this column */
		table.querySelectorAll('td').forEach((cell, index) => {
			if(index > 0 && cell.innerHTML === '') {
				cell.classList.add('empty');
			}
		});
	});

/* ====================== Enquiry Category Field Population ======================  */
	$(".enquiry_type select").change(function(){
		var enquiry_type = $(this).children("option:selected").text();
		$('.gfield.enquiry_category').find('input').val(enquiry_type);
	});

/* ====================== PopUp ======================  */
	function close_popup() {
		$('.popup-container').removeClass('active');
		$('body').removeClass('popup-open');
		Cookies.set('popup_closed', 'true', { expires: 7 });
	}

	function click_outside_popup() {
		$(window).on('click',function(event){
			var target = $(event.target).parents('.popup-container');

			if(!$(target).length){
				close_popup()
			}
		});
	}

	$('.popup-container .btn').on('click', function() {
		Cookies.set('popup_closed', 'true', { expires: 7 });
	});

	$('.popup-container .close').on('click', function() {
		close_popup();
	});

	// If popup exists, pop it up when cookie notice closed
	if($('.popup-container').length) {
		$('.cookie-policy .cookie-close').on('click', function() {
			if(Cookies.get('popup_closed') != 'true') {
				var timeUp = $('.popup-container').attr('time-until-popup');
				timeUp = (timeUp * 1000);

				setTimeout(function(){
					$('body').addClass('.popup-open');
					$('.popup-container').addClass('active');

					click_outside_popup();
				}, timeUp);
			}
		});
	}

	// If popup exists, pop it up as cookies already closed
	if(Cookies.get('popup_closed') != 'true') {
		if($('.popup-container').length) {
			var timeUp = $('.popup-container').attr('time-until-popup');
			timeUp = (timeUp * 1000) + 2000;

			setTimeout(function(){
				$('body').addClass('popup-open');
				$('.popup-container').addClass('active');

				click_outside_popup();
			}, timeUp);
		}
	}

/* ====================== Positioning Image on Dual Carousel ======================  */
	function positionImage(windowWidth) {
    	if(windowWidth > 1439) {
	    	$('.content-and-dual-image-carousel').each(function(index, element) {
	    		if($(this).next('.content-and-dual-image-carousel.images-right').length) {
	    			$(this).addClass('js-align-image');
			    	var position = $(this).next('.content-and-dual-image-carousel.images-right').find('.images').position();
			    	var image = $(this).find('.image-slide:nth-of-type(2)');

			    	$(image).css('left', position['left']);
			    }
	    	});
	    }
	}

	positionImage(windowWidth);
    $(window).resize(function(){
    	windowWidth = $(window).width();
		positionImage(windowWidth);
    });

/* ====================== Anchor Nav ======================  */
	let fix = gsap.utils.toArray('.anchor-navigation')
	fix.forEach((item, index) => {
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: item,
				once: false,
				start:"0 0",
				toggleActions:"restart none none reset",
				end: () => document.documentElement.scrollHeight,
				markers: false,
				toggleClass: 'fixed',
			}
		});
	});

	const $menu = $(".anchor-navigation");
	const $menuItems = $(".anchor-navigation .text-link");

	var clickFlag = false;
    $('.anchor-navigation .text-link').on("click", function(e) {
    	e.preventDefault();
    	clickFlag = true;
		$menuItems.removeClass("active");
		$(this).addClass("active");

		setTimeout(
		function() {
			clickFlag = false;
		}, 1000);

    	var selected = $(this).attr('anchor-link');
		var anchor_block = '[id="'+ selected +'"]';
		$('html,body').animate({
	   		scrollTop: $(anchor_block).offset().top
		});
	});

	$(".anchor-navigation-select").change(function(){
		clickFlag = true;

		setTimeout(
		function() {
			clickFlag = false;
		}, 1000);

		var selected = $(this).val();
		if(selected.length > 0) {
			var anchor_block = '[id="'+ selected +'"]';

			$('html,body').animate({
		   		scrollTop: $(anchor_block).offset().top - 60
			});
		}
	});

	if($menu) {
		let pageContents = gsap.utils.toArray('.block');
		pageContents.forEach((item, index) => {
			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: item,
					start: "top 50%",
					end: "bottom 20%",
					toggleActions: "play none none reverse",
					markers: false,
					onEnter: () => {
						if(clickFlag == false) {
							let item_id = item.id;

							if(windowWidth < 1024) {
								$('.anchor-navigation-select option[value="'+ item_id +'"]').prop('selected', true);
							} else {
								$('.anchor-navigation .text-link').removeClass('active');
								$('.anchor-navigation .text-link[anchor-link="'+ item_id +'"]').addClass('active');
							}
						}
					},
					onEnterBack: () => {
						if(clickFlag == false) {
							let item_id = item.id;

							if(windowWidth < 1024) {
								$('.anchor-navigation-select option[value="'+ item_id +'"]').prop('selected', true);
							} else {
								$('.anchor-navigation .text-link').removeClass('active');
								$('.anchor-navigation .text-link[anchor-link="'+ item_id +'"]').addClass('active');
							}
						}
					},
				}
			});
		});
	}

/* ====================== Price Table Mobile Labels ======================  */
	if(windowWidth < 1024) {
		$('.prices-table td:first-of-type').each(function() {
			var text = $(this).html();
			text = text.replace("January", "Jan");
			text = text.replace("February", "Feb");
			text = text.replace("March", "Mar");
			text = text.replace("April", "Apr");
			text = text.replace("July", "Jul");
			text = text.replace("August", "Aug");
			text = text.replace("September", "Sept");
			text = text.replace("October", "Oct");
			text = text.replace("November", "Nov");
			text = text.replace("December", "Dec");
			text = text.replace("Friday", "Fri");
			text = text.replace("Saturday", "Sat");
			$(this).html(text);
		});
	}

/* ====================== Cookiebot Function to disable for pagespeedinsights ======================  */
window.addEventListener("CookiebotOnDialogInit", function() {
    if (Cookiebot.getDomainUrlParam("CookiebotScan") === "true")
      Cookiebot.setOutOfRegion();
  });

});